import { render, staticRenderFns } from "./taxiCard.vue?vue&type=template&id=16ffca45&"
import script from "./taxiCard.vue?vue&type=script&lang=ts&"
export * from "./taxiCard.vue?vue&type=script&lang=ts&"
import style0 from "./taxiCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports